import t from "lib/i18n";
import useLayout from "hooks/useLayout";
import FeatureFlag from "components/helpers/FeatureFlag";

import "styles/components/booking-fees.scss";

const BookingFees = () => {
  const { isMobile } = useLayout();
  
  return (
    <FeatureFlag name="hidePromotionalText" inverse={true}>
      {isMobile && (
        <div className="otrl-jp__booking-fees">
          {t("noBookingFees")}
        </div>
      )}
    </FeatureFlag>
  );
};

export default BookingFees;
